import CommonDatePicker from "@lhd/components/CommonDatePicker";
import { DATE_TIME_FORMAT } from "@lhd/constants";
import moment, { Moment } from "moment";
import { useState } from "react";
import { ICommonFieldProps } from "../../../../interfaces";

const MONTH_PARSE_FORMATS = [
  DATE_TIME_FORMAT.DATE_QUERY,
  DATE_TIME_FORMAT.DATE_DEFAULT,
  DATE_TIME_FORMAT.DATE_MONTH_JP,
  DATE_TIME_FORMAT.DATE_MONTH_JP_M,
  DATE_TIME_FORMAT.YEAR_MONTH,
  "YYYY-MM",
  "YYYY/MM",
  "YYYY/M",
  moment.ISO_8601,
];

const getMonthValue = (value: any): Moment | undefined => {
  if (value === null || value === undefined || value === "") return undefined;

  const date =
    typeof value === "string"
      ? moment(value.trim(), MONTH_PARSE_FORMATS, true)
      : moment(value);

  return date.isValid() ? date : undefined;
};

const DateMonthEditCell = (props: ICommonFieldProps) => {
  const {
    defaultValue,
    onChange,
    colDef,
    colId,
    getCellValue,
    disabledDate: externalDisabledDate,
    isDisabledDateLoading,
    onOpenChange,
  } = props;
  const isEndDate = colId === "end_date" || colId.endsWith(".end_date");
  const [value, setValue] = useState<Moment | null>(
    () => getMonthValue(defaultValue) || null,
  );
  const disabledDate = (current: Moment) => {
    const { lessThanField, greaterThanField } = colDef;
    const upperBound = lessThanField
      ? getMonthValue(getCellValue?.(lessThanField))
      : undefined;
    const lowerBound = greaterThanField
      ? getMonthValue(getCellValue?.(greaterThanField))
      : undefined;

    const isDisabledByRelatedField =
      Boolean(upperBound && current.isAfter(upperBound, "month")) ||
      Boolean(lowerBound && current.isBefore(lowerBound, "month"));

    return (
      Boolean(isDisabledDateLoading) ||
      isDisabledByRelatedField ||
      Boolean(externalDisabledDate?.(current))
    );
  };

  return (
    <CommonDatePicker
      className="input-field"
      wrapperStyle={{ width: "100%", height: "100%" }}
      picker="month"
      displayFormat={DATE_TIME_FORMAT.DATE_MONTH_JP_M}
      value={value}
      allowClear
      disabledDate={disabledDate}
      onOpenChange={onOpenChange}
      onChange={(_saved, date) => {
        const normalizedDate = date
          ? isEndDate
            ? date.clone().endOf("month")
            : date.clone().startOf("month")
          : null;
        setValue(normalizedDate);
        onChange?.(
          normalizedDate
            ? normalizedDate.format(DATE_TIME_FORMAT.DATE_QUERY)
            : "",
        );
      }}
    />
  );
};

export default DateMonthEditCell;
